import { Messages } from '../../codegen/Localize';
import { IMetricInfo } from '../models/IMetricInfo';
import { Module } from '../Module';
import { Metrics } from '../resources/Metrics';
import { Views } from '../resources/Views';
import { IViewActions } from '../ServerApi/types/IViewActions';
import { ToasterService, ToastType } from './ToasterService';

export class ResumeMetricAction {

  public static $inject = ['$translate', 'ToasterService', 'Views', 'Metrics'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService,
    private views: Views,
    private metrics: Metrics) { }

  public async resumeMetric(metric: IMetricInfo) {
    const viewId = metric.connectedView && metric.connectedView.id;
    if (!viewId) {
      throw new Error(Messages.metricResumeErrorMessage());
    }
    const hasAccess = await this.canAccessView(viewId);
    if (!hasAccess) {
      throw new Error(Messages.metricResumeErrorMessage());
    }

    const result = await this.metrics.resumeMetrics([metric.id]);
    if (!result.errors) {
      this.toaster.pop({
        type: ToastType.Success,
        text: this.$translate.instant('metricResumeSuccess', {
          METRIC_NAME: metric.name,
        }),
        testId: 'resume-metric-success'
      });
    } else {
      throw new Error(Messages.metricResumeErrorMessage());
    }
  }

  private canAccessView(viewId: string) {
    // ensure user has access to view before attempting resume metric
    return this.views.actions(viewId).then((actions: IViewActions) => {
        return actions.launchWebAuthoring;
    });
  }
}

Module.instance().service('ResumeMetricAction', ResumeMetricAction);
